<template>
  <component-wrapper
    :attribute="attribute"
    :attributeName="attributeName"
    :complete-required="completeRequired"
    :entityName="entityName"
    :helpText="helpText"
    :id="id"
    :label="label"
    :shouldRender="shouldRender"
    :required="!!ruleList.length"
    :showHeader="showHeader"
  >
    <v-text-field
      :data-cy="`${entityName}__textFieldNPI--${attributeName}`"
      :disabled="disabled"
      :filled="styleMap.filled"
      :outlined="styleMap.outlined"
      :placeholder="placeholder"
      :rules="ruleList.concat(NPIRule)"
      :solo="styleMap.solo"
      clearable
      counter="10"
      type="number"
      v-model="value"
    >
    </v-text-field>
  </component-wrapper>
</template>
<script>
import userInputMixin from "./userInputMixin";

import ComponentWrapper from "./ComponentWrapper";

export default {
  components: {
    ComponentWrapper,
  },
  data() {
    return {
      NPIRule: [
        v => !v || (!!v && v.length === 10) || "Must be 10 digits long.",
        v => !v || /^[0-9]{10}$/.test(v) || "Must be comprised of numbers.",
      ],
    };
  },
  mixins: [userInputMixin],
};
</script>
